import { Dispatch, Action } from "redux";
import { UpdateArtefact, Environments, SaveArtefactPayload } from "@emisgroup/cohort-builder-kit";
import { ProgressSpinnerSlice } from "../../ProgressSpinner/Index";
import { handleException } from "../../../ErrorMessages/helper";
import { ErrorAlertSlice } from "../../ErrorAlert/Index";
import { ArtefactTypes } from "../Partition/redux/Types";
import { SaveExtractProps } from "./IExtractCreateOrUpdateProps";
import { ExtractModes } from "./redux/Types";
import { Update_Success } from "./Constant";
import { ExtractAddSlice } from  "./index";

const getSpinnerMessage = (mode: ExtractModes): string => {
  return mode === ExtractModes.CREATE ?
    "LoadingMessage.SaveExtract" : "LoadingMessage.UpdateExtract";
};

export const SaveExtract = async (
  dispatch: Dispatch<Action>,
  details: SaveExtractProps,
): Promise<void> => {
  const extractDetails = details.extractDetails;
  const user = details.user;
  const spinnerMessage = getSpinnerMessage(details.mode);
  dispatch(ProgressSpinnerSlice.actions.showProgressBar(spinnerMessage));

  const artefactId = extractDetails?.extractGuid?.trim();
  try {
    const request = {
      "name": extractDetails?.title?.value,
      "type": ArtefactTypes.PARTITION,
      "metaData": []
    } as SaveArtefactPayload;

    if(extractDetails?.description){
      request.description = extractDetails?.description;
    }

    if (artefactId) {
      const response = await UpdateArtefact(
        artefactId,
        request,
        process.env.APP_TARGET_ENV as Environments,
        user?.token as string,
      );

      if (response?.["data"]?.message === Update_Success) {
        dispatch(ExtractAddSlice.actions.setDetailsUpdated(true));
      }
    }
  } catch (ex) {
    handleException(ex, dispatch, "UpdateExtractErrMsg");
  }
  dispatch(ErrorAlertSlice.actions.showAlert(false));
  dispatch(ProgressSpinnerSlice.actions.hideProgressBar());
};
